<template>
  <div class="traffic">
    <div v-if="guide == ''">
      <el-empty description="没有内容额"></el-empty>
    </div>
    <div v-else>
      <img class="guideImg" :src="guide" />
    </div>
  </div>
</template>

<script>
import { read } from "@/api/pilotService/guide";
export default {
  data() {
    return {
      guide: "",
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      read()
        .then((res) => {
          ;
          if (res.code === 0) {
            this.guide = res.data.guide;
          }
        })
        .catch((err) => {
          ;
        });
    },
  },
};
</script>

<style scoped>
.traffic{
  min-height: calc(100% - 123.2px);
}
.guideImg{
  margin: 0 auto;
  width: 80%;
}
</style>